import AbstractService from '@/services/abstractService'

class RepresentativeService extends AbstractService {
    endpoint = 'clients'

    index(id) {
      return this.http.get(`${this.endpoint}/${id}/representative`, { params: { dashboard: true } })
    }

    post(id, data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.post(`${this.endpoint}/${id}/representative`, formData)
    }

    put(data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()

      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.put(`${this.endpoint}/${data.id}`, formData)
    }


    delete(data) {
      console.log('data', data)
      return this.http.delete(`${this.endpoint}/${data}`)
    }
}

const Service = new RepresentativeService()

export default Service
